<template>
  <b-col class="p-4">
    <h5 class="text-center mb-4">{{ $t('FinalConfirmation') }}</h5>
    <!-- Validation formulaire -->
    <ValidationProvider 
      rules="required" 
      :name="$t('Password')" 
      v-slot="{ errors, valid }" 
      ref="passwordProvider">
      <b-form-group :invalid-feedback="errors[0]" class="mb-4">
        <!-- Champ login invisible : le gestionnaire de mots de passe du navigateur couple le login au mot de passe ici,
             plutôt que d'insérer le login dans un autre champ texte de la page (ex : recherche d'un tableau) -->
        <input
          type="text"
          name="username"
          autocomplete="username"
          tabindex="-1"
          aria-hidden="true"
          class="off-screen"/>
        <label for="Input_Password" class="font-weight-bold">
          {{ $t('PleaseEnterYourPasswordToSign') }}
        </label>
        <b-form-input
          id="Input_Password"
          type="password"
          autocomplete="current-password"
          v-model="password"
          :state="errors[0] ? false : (valid ? true : null)"
          :placeholder="$t('YourPassword')"
          @keydown.enter.native="onConfirm"/>
      </b-form-group>
    </ValidationProvider>
    <b-col class="d-flex justify-content-between align-items-center mt-5">
      <!-- Bouton de retour en arrière -->
      <b-button @click="OnBack" variant="outline-secondary" pill>
        {{ $t('Back') }}
      </b-button>
      <!-- Bouton de validation -->
      <b-button 
        @click="onConfirm" 
        variant="success" 
        pill 
        :disabled="isSending">
        <span v-if="isSending">
          <b-spinner small></b-spinner> {{ $t('Send') }}...
        </span>
        <span v-else>
          {{ $t('Validate') }} 
          <font-awesome-icon icon="fa-solid fa-check" class="ml-2"/>
        </span>
      </b-button>
    </b-col>
  </b-col>
</template>

<script lang="ts">
/**
 * Composants VUE
 */
import { Component, Vue, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

/**
 * Validateur formulaire
 */
import { ValidationProvider } from 'vee-validate';

/**
 * Traduction
 */
import locale from '../../locales/SMA.json';

/**
 * Utilitaire
 */
import { SMAUtils } from '../SMAUtils';

@Component({
  components: { 
    ValidationProvider 
  },
  i18n: { messages: locale }
})
/**
 * Composant pour écriture du mot de passe
 */
export default class PasswordValidation extends mixins(Vue, SMAUtils) {
  
    @Prop({ default: false }) 
    private isSending!: boolean;

    /**
     * Mot de passe
     */
    private password: string = "";

    /**
     * Valide le formulaire et émet le mot de passe au parent
     */
    private async onConfirm() {
      // Vérification via VeeValidate
      const provider = this.$refs.passwordProvider as any;
      const { valid } = await provider.validate(this.password);

      if (!valid || !this.password) {
        this.showToast(this.$t('PleaseEnterYourPassword').toString(), "warning", "Password");
        return;
      }

      // On émet l'événement 'confirm' avec le mot de passe
      this.$emit('Submit', this.password);
    }

    /**
     * Retour en arrière dans les étapes
     */
    protected OnBack(){
      this.$emit('Back');
    }
}
</script>
<style scoped>
  /**
   * Champ positionné hors de l'écran mais présent dans le DOM
   * (display:none est ignore par les gestionnaires de mots de passe)
   */
  .off-screen {
    position: absolute;
    left: -9999px;
    width: 1px;
    height: 1px;
    opacity: 0;
  }
</style>